const POLL_INTERVAL = 5_000;

function getApiBase(): string {
  const envUrl = (import.meta as any).env?.VITE_API_URL;
  if (envUrl) return envUrl;
  if (typeof window !== 'undefined' && window.location?.hostname !== 'localhost') return '';
  return 'http://localhost:4000';
}

export class ServerHealthService {
  private static instance: ServerHealthService;
  private _online = true;
  private timer: ReturnType<typeof setInterval> | null = null;
  private onOffline: (() => void) | null = null;
  private onOnline: (() => void) | null = null;

  private constructor() {}

  static getInstance(): ServerHealthService {
    if (!ServerHealthService.instance) ServerHealthService.instance = new ServerHealthService();
    return ServerHealthService.instance;
  }

  static _resetInstance(): void { (ServerHealthService as any).instance = undefined; }

  get online(): boolean { return this._online; }

  start(callbacks: { onOffline: () => void; onOnline: () => void }): void {
    this.onOffline = callbacks.onOffline;
    this.onOnline = callbacks.onOnline;
    if (this.timer !== null) clearInterval(this.timer);
    this.timer = setInterval(() => void this._check(), POLL_INTERVAL);
  }

  stop(): void {
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  private async _check(): Promise<void> {
    try {
      const res = await fetch(`${getApiBase()}/api/health`, { method: 'GET', cache: 'no-store' });
      if (res.ok) {
        if (!this._online) { this._online = true; this.onOnline?.(); }
      } else {
        if (this._online) { this._online = false; this.onOffline?.(); }
      }
    } catch {
      if (this._online) { this._online = false; this.onOffline?.(); }
    }
  }
}
